import React from 'react'
import { css } from 'glamor'

import { Auth } from 'aws-amplify'

interface IProps {
  updateErrorMessage: (message: string) => void;
  switchState: (state: string) => void;
}
interface IState {
  username: string;
  password: string;
  email: string;
  phone_number: string;
  authCode: string;
  showConfirmation: boolean;
}
class SignUp extends React.Component<IProps, IState> {
  state = {
    username: '',
    password: '',
    email: '',
    phone_number: '',
    authCode: '',
    showConfirmation: false
  }

  signUp = () => {
    const { username, password, email, phone_number } = this.state
    
    Auth.signUp({
        username,
        password,
        attributes: {
            email,
            phone_number
            // 'custom:favorite_flavor': 'Cookie Dough' - custom attribute, not standard
        }        
    })
    .then(() => this.setState({ showConfirmation: true }))
    .catch(err => {
      console.log('error signing up: ', err)
      this.props.updateErrorMessage(err.message)
    })
  }
  confirmSignUp = () => {
    Auth.confirmSignUp(this.state.username, this.state.authCode)
    .then(() => this.props.switchState('showSignIn'))
    .catch(err => console.log('error confirming signing up: ', err))
  }
  render() {
    const { showConfirmation } = this.state
    return (
      <div {...css(styles.container)}>
        {
          !showConfirmation && (
            <div {...css(styles.formContainer)}>
              <h2 {...css(styles.signUpHeader)}>Sign Up</h2>
              <input
                {...css(styles.input)}
                placeholder='Email'
                onChange={({target: { value }}) => this.setState({
                  username:  value,
                  email: value,
                })}
              />
              <input
                {...css(styles.input)}
                placeholder='Password'
                type='password'
                onChange={({target: { value }}) => this.setState({
                  password:  value,
                })}
              />           
              {                 
              <input
                {...css(styles.input)}
                placeholder='Phone Number'
                onChange={({target: { value }}) => this.setState({
                  phone_number:  value,
                })}
              />
              }
              <div {...css(styles.button)} onClick={this.signUp}>
                <p {...css(styles.buttonText)}>Sign Up</p>
              </div>
            </div>
          )
        }
        {
          showConfirmation && (
            <div {...css(styles.formContainer)}>
              <input
                onChange={({target: { value }}) => this.setState({
                  authCode:  value,
                })}
                {...css(styles.input)}
                placeholder='Confirmation Code'
              />
              <div {...css(styles.button)} onClick={this.confirmSignUp}>
                <p {...css(styles.buttonText)}>Confirm Sign Up</p>
              </div>
            </div>
          )
        }
      </div>
    )
  }
}

const styles = {
  signUpHeader: {
    textAlign: 'left',
    margin: '0px 0px 20px'
  },
  button: {
    padding: '10px 60px',
    backgroundColor: '#ffb102',
    cursor: 'pointer',
    borderRadius: '30px',
    marginTop: 10,
    marginBottom: 10,
    ':hover': {
      backgroundColor: '#ffbb22'
    }
  },
  buttonText: {
    margin: 0,
    color: 'white'
  },
  container: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '15px',
  },
  formContainer: {
    padding: 20,
    width: 400,
    display: 'flex',
    flexDirection: 'column',
    boxShadow: "0px 0px 2px rgba(0, 0, 0, .2)",
    borderRadius: 20
  },
  input: {
    height: 40,
    marginBottom: '10px',
    border: 'none',
    outline: 'none',
    borderBottom: '2px solid #ffb102',
    fontSize: '16px',
    '::placeholder': {
      color: 'rgba(0, 0, 0, .3)'
    }
  },
}

export default SignUp
